import { render } from "./editor.vue?vue&type=template&id=d3e42158"
import script from "./editor.vue?vue&type=script&lang=ts"
export * from "./editor.vue?vue&type=script&lang=ts"
script.render = render

export default script